import { types } from 'mobx-state-tree';

export const SpatialReference = types.model('SpatialReference', {
  latestWkid: types.maybeNull(types.number),
  wkid: types.maybeNull(types.number)
});
